import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseLetterSpacingOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-letter-spacing-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

interface ItemLetterSpacingOptionProps {
  className?: string;
}

export function ItemLetterSpacingOption({className = ''}: ItemLetterSpacingOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemLetterSpacing = useGetKeyFromTextStylesActiveItem('letterSpacing');
  const activeItemScaleX = useGetKeyFromActiveItem('scaleX');

  if (!activeItem || !('textStyles' in activeItem) || itemLetterSpacing === undefined || activeItemScaleX === undefined) {
    throw new Error(`Item doesn't have textStyles property`);
  }
  const updateLetterSpacing = (letterSpacing: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        textStyles: {
          letterSpacing,
        },
      },
      {
        undoable,
      }
    );
  };

  return <ItemBaseLetterSpacingOption className={className} letterSpacing={itemLetterSpacing} scaleX={activeItemScaleX} onChangeLetterSpacing={updateLetterSpacing} />;
}
